import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import SalesPeriodView from '../../Model/Individual/StatisticsModel/SalesPeriodView';

import IntroMarkdown from './IntroMarkdown';

export default function SalesPeriodRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { intro, startDate, endDate, monthData, periodSalesPrice } = data;

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper $isDark={isDark}>
        <SalesPeriodView
          startDate={startDate}
          endDate={endDate}
          monthData={monthData || []}
          periodSalesPrice={periodSalesPrice || 0}
          settlementPrice={0}
          expectedSettlementPrice={0}
          isOpenPartnerGymSales={true}
          showSettlement={false} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  padding: 20px 24px;

  width: calc(100% - 48px);

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;
